import React, { useEffect, useState, useRef } from "react";
import "../../../styles/Auth/campaign.css";
import { FaWhatsapp, FaEnvelope, FaSms } from "react-icons/fa";
import { Box } from '@mui/material';
import { getData, postData } from "../../../webService/webservice.js";
import { useParams, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { toast } from "react-toastify";
const SendCampaignPage = () => {
    const navigate = useNavigate();
    const { campaignId } = useParams();
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [medium, setMedium] = useState("");
    const [description, setDescription] = useState("");
    const [customerFilter, setCustomerFilter] = useState("All");
    const [customers, setCustomers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [refreshKey, setRefreshKey] = useState(0);
    const [fetching, setFetching] = useState(false);
    const [sending, setSending] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [customFilters, setCustomFilters] = useState({
        location: "",
        gender: "",
        ageMin: "",
        ageMax: "",
        spendMin: "",
        lastActiveDays: ""
    });

    const [limit, setLimit] = useState(5);
    const headings = [
        'SL',
        'Name',
        'PhoneNumber',
        'Location',
        'Action',
    ];
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    const handleCustomChange = (e) => {
        setCustomFilters({
            ...customFilters,
            [e.target.name]: e.target.value
        });
    };
    const handleClearFilters = () => {
        setCustomFilters({
            location: "",
            gender: "",
            ageMin: "",
            ageMax: "",
            lastActiveDays: ""
        });
        triggerRefresh();
    };
    useEffect(() => {
        const token = sessionStorage.getItem("sessionToken");
        fetchCustomers(currentPage, limit, token, customerFilter);
    }, [currentPage, limit, refreshKey, customerFilter]);


    const fetchCustomers = async (page, limit) => {
        const params = {
            page,
            limit,
        }
        try {
            setFetching(true);
            const token = sessionStorage.getItem("sessionToken");
            let endpoint = "";

            if (customerFilter === "All") {
                endpoint = "customers/customers";
            } else if (customerFilter === "Custom") {
                endpoint = "customers/customers";
                if (customFilters.location) params.location = customFilters.location;
                if (customFilters.gender) params.gender = customFilters.gender;
                if (customFilters.ageMin) params.ageMin = customFilters.ageMin;
                if (customFilters.ageMax) params.ageMax = customFilters.ageMax;
                if (customFilters.lastActiveDays) params.lastActiveDays = customFilters.lastActiveDays;

            }

            if (endpoint) {
                const data = await getData(endpoint, params, token);
                console.log("API Full Response: ", data);

                // Handle paginated results or flat array
                const results = data?.data?.[0]?.paginatedResults || data?.data || [];
                const count = data?.data?.[0]?.totalCount || 0;
                const totalPages = Math.ceil(count / limit);
                setCustomers(results);
                setTotalCount(count);
                setTotalPages(totalPages);
            }
        } catch (error) {
            console.error("Failed to load customers", error);
        } finally {
            setFetching(false);
        }
    };

    const handleSend = async () => {
        if (!medium) {
            alert("Please select a medium (Email, WhatsApp, SMS)");
            return;
        }
        if (!selectedCustomers.length) {
            alert("Please select at least one customer");
            return;
        }

        try {
            const payload = { customerIds: selectedCustomers, description, medium };

            let endpoint = "";
            if (medium === "Email") {
                endpoint = `/campaigns/campaign/${campaignId}/sendemail`;
            } else if (medium === "SMS") {
                endpoint = `campaigns/${campaignId}/send-sms`;
            } else if (medium === "Whatsapp") {
                endpoint = `campaigns/${campaignId}/send-whatsapp`;
            }

            postData(endpoint, payload, sessionToken)
                .then((response) => {
                    console.log("📤 Campaign Send Response:", response);
                    toast.success(`${medium} campaign sent successfully!`);
                    triggerRefresh(); // refresh history table
                })
                .catch((error) => {
                    console.error("❌ Failed to send campaign", error);
                    toast.error("Failed to send campaign. Try again.");
                });

            // ✅ Immediately free UI
            toast.info(`Your ${medium} campaign is being sent in background...`);
            navigate("/campaigns");
        } catch (error) {
            console.error("❌ Failed to send campaign", error);
            alert("Failed to send campaign. Try again.");
        }
        finally {
            setSending(false);
        }
    };
    return (
        <div className="campaign-container">
            <div className="campaign-card">
                {/* Select customers + Medium */}
                <div className="campaign-grid">
                    {/* Customers */}
                    <div className="campaign-box">
                        <h3 className="campaign-title">Select customers</h3>
                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    name="customerFilter"
                                    value="All"
                                    checked={customerFilter === "All"}
                                    onChange={(e) => setCustomerFilter(e.target.value)}
                                />
                                All customers
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="customerFilter"
                                    value="Custom"
                                    checked={customerFilter === "Custom"}
                                    onChange={(e) => setCustomerFilter(e.target.value)}
                                />
                                Custom
                            </label>
                        </div>
                        {customerFilter === "Custom" && (
                            <div className="custom-filter-panel">
                                <div className="filter-heading">
                                    <h4>Custom Filters</h4>
                                </div>
                                <div className="custom-filter-group location">
                                    <label className="custom-filter-label">Location</label>
                                    <input
                                        type="text"
                                        name="location"
                                        value={customFilters.location}
                                        onChange={handleCustomChange}
                                        placeholder="City / State"
                                        className="custom-filter-input"
                                    />
                                    <label className="custom-filter-label">Gender</label>
                                    <select
                                        name="gender"
                                        value={customFilters.gender}
                                        onChange={handleCustomChange}
                                        className="custom-filter-select"
                                    >
                                        <option value="">Any</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="others">Other</option>
                                    </select>
                                </div>
                                <div className="custom-filter-group agerange">
                                    <label className="custom-filter-label">Age Range</label>
                                    <div className="custom-filter-age">
                                        <input
                                            type="number"
                                            name="ageMin"
                                            value={customFilters.ageMin}
                                            onChange={handleCustomChange}
                                            placeholder="Min Age"
                                            className="custom-filter-input"
                                        />
                                        <input
                                            type="number"
                                            name="ageMax"
                                            value={customFilters.ageMax}
                                            onChange={handleCustomChange}
                                            placeholder="Max Age"
                                            className="custom-filter-input"
                                        />
                                    </div>
                                </div>
                                <div className="custom-filter-group activeDays">
                                    <label className="custom-filter-label">Last Active (days)</label>
                                    <input
                                        type="number"
                                        name="lastActiveDays"
                                        value={customFilters.lastActiveDays}
                                        onChange={handleCustomChange}
                                        placeholder="e.g. 30"
                                        className="custom-filter-input"
                                    />
                                </div>
                                <div className="custom-filter-actions">
                                    <button onClick={triggerRefresh} className="custom-filter-btn apply">
                                        Apply Filters
                                    </button>
                                    <button onClick={handleClearFilters} className="custom-filter-btn clear">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        )}
                        <TableContainer
                            component={Paper}
                            sx={{
                                borderRadius: '12px',
                                overflow: 'auto',
                                maxHeight: '400px',
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}
                        >
                            <Table
                                className="custom-product-table"
                                sx={{
                                    '& td, & th': {
                                        border: 'none',
                                    },
                                    border: 'none',

                                }}
                            >
                                <TableHead className="custom-product-head">
                                    <TableRow>
                                        {headings.map((heading, index) => (
                                            <TableCell
                                                key={index}
                                                sx={{
                                                    border: 'none',
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    position: "sticky",
                                                    top: 0,
                                                    backgroundColor: '#e6cf80',
                                                    zIndex: 1,

                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '4px',
                                                        color: '#000000',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {heading}
                                                </Typography>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {!customers || customers.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography
                                                    sx={{
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '20px',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    No customers found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        customers.map((customer, index) => (
                                            <TableRow key={customer._id}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {customer.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {customer.phoneNumber}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={commonCellStyle}>
                                                    {customer.city}
                                                </TableCell>
                                                <TableCell>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            gap: 3,
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            name="selectedCustomer"
                                                            value={customer._id} // or customer.phoneNumber if you want unique value
                                                            checked={selectedCustomers.includes(customer._id)}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    // add to list
                                                                    setSelectedCustomers((prev) => [...prev, customer._id]);
                                                                } else {
                                                                    // remove from list
                                                                    setSelectedCustomers((prev) =>
                                                                        prev.filter((id) => id !== customer._id)
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="service-bottom">
                            <div className="service-section show-entries">
                                <span className="text-label">Show</span>
                                <select className="entries-select" value={limit}
                                    onChange={handleItemsPerPageChange}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                </select>
                                <span className="text-label">Entries</span>
                            </div>
                            <div className="service-section showing-range">
                                {`Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                            </div>
                            <div className="service-section spacer"></div>
                            <div className="service-section pagination-buttons">
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange("prev")}
                                >Previous</button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange("next")}
                                >Next</button>
                            </div>
                        </div>
                        {limit > 5 && customers.length > 5 && (
                            <div className="scroll-down-hint">
                                <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                    Scroll down to see more customers
                                </Typography>
                            </div>
                        )}
                    </div>

                    {/* Medium */}
                    <div className="campaign-box">
                        <h3 className="campaign-title">Select Medium</h3>
                        <div className="medium-options">
                            <label className="medium-item">
                                <div className="medium-left">
                                    <FaWhatsapp className="whatsapp-icon" />
                                    <span>Whatsapp</span>
                                </div>
                                <input
                                    type="radio"
                                    name="medium"
                                    value="Whatsapp"
                                    checked={medium === "Whatsapp"}
                                    onChange={(e) => setMedium(e.target.value)}
                                />
                            </label>
                            <label className="medium-item">
                                <div className="medium-left">
                                    <FaEnvelope className="email-icon" />
                                    <span>Email</span>
                                </div>
                                <input
                                    type="radio"
                                    name="medium"
                                    value="Email"
                                    checked={medium === "Email"}
                                    onChange={(e) => setMedium(e.target.value)}
                                />
                            </label>
                            <label className="medium-item">
                                <div className="medium-left">
                                    <FaSms className="sms-icon" />
                                    <span>SMS</span>
                                </div>
                                <input
                                    type="radio"
                                    name="medium"
                                    value="SMS"
                                    checked={medium === "SMS"}
                                    onChange={(e) => setMedium(e.target.value)}
                                />
                            </label>
                        </div>
                        <div className="campaign-actions">
                            <button className="cancel-btn" onClick={() => { setDescription(""); navigate('/campaigns'); }}>
                                Cancel
                            </button>
                            <button className="send-btn" onClick={handleSend}>
                                {sending ? (
                                    <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <ClipLoader size={20} color="#fff" />
                                        Sending...
                                    </span>
                                ) : (
                                    "Send"
                                )}
                            </button>
                        </div>
                    </div>
                </div>



                {/* Buttons */}

            </div>
        </div >
    );
};

export default SendCampaignPage;
